import { motion } from "framer-motion";
import { CalendarCheck, Armchair, Mic2, Globe2 } from "lucide-react";

const STEPS = [
  { icon: CalendarCheck, title: "Curated Sync", desc: "A relaxed pre-call with Ankush. No scripted questionnaires — just alignment on the stories that matter." },
  { icon: Armchair, title: "Studio Sanctuary", desc: "A private lounge setup, in-studio or remote. Coffee, calm, and zero pressure." },
  { icon: Mic2, title: "Raw Conversation", desc: "60–90 minutes of uninhibited dialogue. The pauses and pivots stay in — that's where the truth lives." },
  { icon: Globe2, title: "Global Distribution", desc: "Full episode plus a vault of clips, mastered and delivered to your team for your own channels too." },
];

const ExperienceFlow = () => {
  return (
    <section id="episode-flow" className="relative py-16 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
        >
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-amber-400">The Guest Journey</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            From invite to airwaves, in four steps.
          </h2>
        </motion.div>

        <div className="mt-10 sm:mt-16 relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-amber-500/30 to-transparent" />
          <div className="space-y-6 sm:space-y-8 md:space-y-0">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
                className={`md:grid md:grid-cols-2 md:gap-16 items-center ${i > 0 ? "md:mt-14" : ""}`}
              >
                <div data-testid={`flow-step-${i + 1}`} className={`clay-card p-6 sm:p-7 neu-lift ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <div className="flex items-center gap-3 sm:gap-4">
                    <span className="clay-badge w-12 h-12 rounded-2xl flex items-center justify-center shrink-0">
                      <s.icon className="w-5 h-5 text-amber-400" />
                    </span>
                    <div>
                      <p className="font-mono-iq text-[10px] tracking-[0.25em] text-amber-400/80">STEP 0{i + 1}</p>
                      <h3 className="font-display text-lg font-semibold mt-0.5">{s.title}</h3>
                    </div>
                  </div>
                  <p className="mt-4 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                </div>
                <div className={`hidden md:flex ${i % 2 === 1 ? "md:order-1 justify-start" : "justify-end"}`}>
                  <span className="font-display text-7xl font-extrabold outline-massive select-none">0{i + 1}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceFlow;
